import { Grid } from "@mui/material";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { BidPackBase } from "./BidPackBase";
import { BidPackDetails } from "./BidPackDetails";

export const BidPackInformationForm = ({ disabledFields }: MdmFormProps) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <BidPackBase disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={3}>
        <BidPackDetails disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
};
